import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IEmployeeRepository } from "./IEmployeeRepository";
import { environment } from "../../../../environments/environment";
import { Employee } from "../../../models/HR/Employee/employee";
import { EmployeeVisaDetail } from "src/app/models/HR/EmployeeVisaDetail/employeeVisaDetail";

@Injectable()
export class EmployeeRepository extends GenericRepository<Employee> implements IEmployeeRepository {

  url: string = environment.urlAddress;
  constructor(protected _http: HttpClient) {
    super(_http, 'api/Employee', environment.urlAddress);
  }
  GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
    return this.Get('/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText).pipe(map(this.extractData), catchError(this.handleError));
  }
  SaveRec(item: Employee): Observable<ResponseModel> {
    return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
  }
  LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
    return this.GetById('/NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
  }
  LoadRec(code: string): Observable<ResponseModel> {
    return this.GetById('/GetRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
  }
  DeleteRec(code: string): Observable<ResponseModel> {
    return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
  }

 ResetPassword(item: any): Observable<ResponseModel> {
  return this.PostData('/ResetPassword', item)
    .pipe(map(this.extractData), catchError(this.handleError));
}

  GetUserById(id: number): Observable<ResponseModel> {
    return this._http.get<ResponseModel>(
      `${this.url}/api/Employee/GetUserById/${id}`
    ).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }


}